<template>
    <div>
        <DocumentsC />
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import DocumentsC from '@/components/DocumentsC.vue';

export default {
    name: 'Administration',
    components: {
        DocumentsC
    },
    computed: {},
    methods: {}
};
</script>
